import { render, staticRenderFns } from "./ReviewNominationModal.vue?vue&type=template&id=095603e0&scoped=true&"
import script from "./ReviewNominationModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReviewNominationModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReviewNominationModal.vue?vue&type=style&index=0&id=095603e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095603e0",
  null
  
)

export default component.exports